export default class ResumeSearchResult {
  reloadPageByMemberSwitchesCookies() {
    if(window.location.href.includes("resume_search_results")){
      var interval = setInterval(function(){
        let new_page = parseInt(Cookie.getCookie(gon.resume_search_result_cookies_key))
        if(new_page && new_page != gon.current_page) {
          clearInterval(interval)
          let params = window.location.search.replace("?", "")
          let list_params_accepted = params.split("&").filter(item => !item.includes("page"))
          list_params_accepted.push("page=" + new_page)
          let new_params = list_params_accepted.join("&")

          let origin_location = window.location.origin
          let path_name = window.location.pathname
          window.location.href = origin_location + path_name + "?" + new_params
        }
      }, 1000)
    }
  }
}
